<script lang="ts" setup>
import { digitsEnToFa } from "@persian-tools/persian-tools"
import { toTypedSchema } from "@vee-validate/valibot"
import * as v from "valibot"
import { useForm } from "vee-validate"

const { loading } = defineProps<{
	seconds: number
	isCounting: boolean
	loading: boolean
	phoneNumber: string
}>()

const emit = defineEmits<{
	submit: [values: string[]]
	back: []
	resendSms: []
}>()

const optInput = useTemplateRef("optInput")

const form = useForm({
	validationSchema: toTypedSchema(
		v.object({
			otp: v.pipe(v.array(v.string()), v.length(6)),
		}),
	),
	initialValues: {
		otp: [],
	},
})

const onSubmit = form.handleSubmit((values) => {
	if (loading)
		return
	emit("submit", values.otp)
})

function resendSms() {
	form.setFieldValue("otp", [])
	emit("resendSms")
	optInput.value?.focus()
}
</script>

<template>
	<LoginContainer>
		<div class="flex flex-col items-center justify-center gap-y-8">
			<div class="flex gap-x-1 text-xl md:text-2xl">
				کد پیامکی رو وارد کن
			</div>

			<div class="flex flex-col items-center justify-center gap-y-2">
				<div class="text-center text-xs md:text-sm">
					کد یک بار مصرف ورود به شماره {{ digitsEnToFa(phoneNumber) }} پیامک میشه. اون رو اینجا وارد کن
				</div>

				<div class="flex items-center">
					<div class="whitespace-pre text-sm text-foreground/70">
						شماره اشتباهه؟
					</div>

					<Btn
						class="text-[#5661F6] hover:bg-[#696CFF]/20"
						type="button"
						@click="emit('back')">
						دوباره شماره رو وارد کن
					</Btn>
				</div>
			</div>

			<NuxtImg
				src="/images/Otp_image.png"
				width="175"
				format="webp"
				fit="inside"
				height="175" />

			<div class="w-full">
				<form
					class="flex flex-col gap-3"
					@submit="onSubmit">
					<UFormField
						v-slot="{ setValue, handleBlur, value }"
						name="otp">
						<!-- overflow hidden for otp problem on phone (make screen scroll) -->
						<UFormItem class="overflow-hidden p-1">
							<UFormControl>
								<OtpInput
									ref="optInput"
									group-class="flex justify-center gap-3 w-full"
									item-class="size-11 md:size-13 bg-foreground/7 border-none rounded-xl!"
									:size="6"
									:model-value="value"
									@complete="onSubmit()"
									@blur="handleBlur"
									@update:model-value="setValue($event)" />
							</UFormControl>
						</UFormItem>
					</UFormField>

					<div class="my-1 w-full">
						<div class="flex items-center">
							<div class="flex-grow border-t border-[#DEE4ED]" />
						</div>
					</div>

					<div class="flex flex-col gap-y-1">
						<div
							v-if="isCounting"
							class="flex items-center justify-center text-xl text-[#675B5B]">
							{{ seconds }}
						</div>

						<div class="flex justify-center">
							<div class="flex items-center text-center">
								<div class="whitespace-pre text-sm">
									کد ارسال نشد؟
								</div>

								<Btn
									class="text-[#381DDB] hover:bg-[#696CFF]/20"
									type="button"
									:disabled="isCounting || loading"
									@click="resendSms">
									دوباره ارسال کن
								</Btn>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</LoginContainer>
</template>
